var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.claim.claim_status.name === "Closed"
      ? _c("div", { staticClass: "col-12 pr-0 pl-0" }, [
          _c("div", { staticClass: "claim-resolved-indicator-wrap" }, [
            _c("div", { staticClass: "col-9 px-0 flex" }, [
              _c("span", { staticClass: "fa fa-clipboard d-block" }),
              _vm._v(" "),
              _c("h3", { staticClass: "text" }, [
                _vm._v(
                  "\n          Closed claim (" +
                    _vm._s(_vm.claim.claim_resolution.name) +
                    ") - " +
                    _vm._s(_vm.claim.title) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.$_can("claims.update") || _vm.$_can("claims.view-own")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-3 px-0 text-right d-flex justify-content-end"
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "d-flex",
                        attrs: { to: "/claims/edit/" + _vm.claim.id }
                      },
                      [_c("p", [_vm._v("See claim")])]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      : _c("div", { staticClass: "col-12 pr-0 pl-0" }, [
          _c("div", { staticClass: "claim-indicator-wrap" }, [
            _c("div", { staticClass: "col-9 px-0 flex" }, [
              _c("span", { staticClass: "fa fa-clipboard" }),
              _vm._v(" "),
              _c("h3", { staticClass: "text" }, [
                _vm._v(
                  "\n          Unresolved claim - " +
                    _vm._s(_vm.claim.title) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.$_can("claims.update") || _vm.$_can("claims.view-own")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-3 px-0 text-right d-flex justify-content-end"
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "d-flex",
                        attrs: { to: "/claims/edit/" + _vm.claim.id }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "d-none d-lg-block d-md-block d-xl-block"
                          },
                          [_vm._v("See claim")]
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "fa fa-arrow-right" })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1570d1a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1570d1a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobClaimBanner.vue
// module id = null
// module chunks = 